import { useState } from 'react';

import { uuid } from '@/util';

import VToastContainer from './VToastContainer';
import { VToastContext } from './context';
import type { VBaseToastItem } from './type';

const VToastProvider = ({ children }: React.PropsWithChildren) => {
  const [toastList, setToastList] = useState<VBaseToastItem[]>([]);

  const addToast = (toast: Omit<VBaseToastItem, 'id'>) => {
    setToastList(prev => [...prev, { id: uuid(), ...toast }]);
  };

  const removeToast = (id: string) => {
    setToastList(prev => prev.filter(item => item.id !== id));
  };

  return (
    <VToastContext.Provider value={{ toastList, addToast, removeToast }}>
      <VToastContainer />
      {children}
    </VToastContext.Provider>
  );
};

export default VToastProvider;
